<template>
  <div id="app">
    <Notification />
  </div>
</template>

<script>
import Notification from "./components/NotificationComp.vue";

export default {
  name: "App",
  components: {
    Notification,
  },
};
</script>

<style>
#app {
  text-align: center;
  margin-top: 60px;
  font-family: "Google Sans", "Roboto", arial, sans-serif;
  font-size: 14px;
}
</style>
